module.exports = __webpack_public_path__ + "img/twitter.c8bb5235.svg";